import { useTranslations } from 'next-intl';
import { IProduct } from '@monofront/types';
import { VALUES } from '@monofront/business/constants';
import {
  getFormattedDiets,
  getFormattedGermanValues,
  getFormattedValues,
} from '@monofront/business/utils';
import useI18n from '@hooks/i18n/useI18n';
import DietsAndValuesContainer from '@components/Values/DietsAndValuesContainer';
import Values from '@components/Values';
import Diets from '@components/Values/Diets';
import GermanValues from '@components/Values/GermanValues';

interface IProductCharacteristicsProps {
  product: IProduct;
}

/* These values are filtered as they appear in the Hero Image section */
const filteredValues = [
  VALUES.ANTIWASTE,
  VALUES.FALLINGPRICE,
  VALUES.FROZENPRICE,
];

const ProductCharacteristics: React.FC<IProductCharacteristicsProps> = ({
  product,
}) => {
  const tProducts = useTranslations('Products');
  const { isFrenchMarket } = useI18n();

  const formattedValues = getFormattedValues(product.values).filter(
    (value) => !filteredValues.includes(value.toLocaleUpperCase()),
  );
  const formattedGermanValues = getFormattedGermanValues(product.values);
  const formattedDiets = getFormattedDiets(product.diets);

  if (
    !formattedValues.length &&
    !formattedGermanValues.length &&
    !formattedDiets.length
  ) {
    return null;
  }

  return (
    <>
      <h3 className="tw-lf-body-xbold-md tw-mb-4 tw-mt-6">
        {tProducts('characteristics')}
      </h3>
      <DietsAndValuesContainer size="lg">
        {isFrenchMarket ? (
          <>
            <Values values={formattedValues} size="lg" enableSidePanel />
            <Diets values={formattedDiets} size="lg" enableSidePanel />
          </>
        ) : (
          <GermanValues
            values={formattedGermanValues}
            size="lg"
            enableSidePanel
          />
        )}
      </DietsAndValuesContainer>
    </>
  );
};

export default ProductCharacteristics;
